import RadioCardListPage from "@components/RadioCardListPage"
import {
  getIsFemaleFromLocalStorage,
  isHairstyleFlow,
  isHomeDesignFlow,
  isProfessionalFlow,
} from "@helpers/localStorage"

const MAIN_GOAL_OPTIONS = [
  { emoji: "✨", key: "improve" },
  { emoji: "🎭", key: "experiment" },
  { emoji: "💼", key: "professional" },
  { emoji: "🎉", key: "fun" },
  { emoji: "💪", key: "confidence" },
]

const HOME_ROOM_OPTIONS = [
  { emoji: "🛋️", key: "livingRoom" },
  { emoji: "🛏️", key: "bedroom" },
  { emoji: "🍳", key: "kitchen" },
  { emoji: "💼", key: "homeOffice" },
  { emoji: "🏠", key: "multipleRooms" },
]

function getFlowConfig(isFemale: boolean) {
  if (isHairstyleFlow()) {
    return {
      translationKey: "hairstyleChoice",
      options: [
        { emoji: "✂️", key: "short" },
        { emoji: isFemale ? "💁‍♀️" : "💁‍♂️", key: "long" },
        { emoji: "🎨", key: "color" },
        { emoji: "〰️", key: "curly" },
        { emoji: "💫", key: "bangs" },
        { emoji: "🌿", key: "natural" },
      ],
    }
  }
  if (isProfessionalFlow()) {
    return {
      translationKey: "professionalFilter",
      options: [
        { emoji: "📸", key: "linkedin" },
        { emoji: "👕", key: "businessCasual" },
        { emoji: isFemale ? "🤵‍♀️" : "🤵‍♂️", key: "formal" },
        { emoji: "🎨", key: "creative" },
        { emoji: "🌴", key: "notNeeded" },
      ],
    }
  }
  if (isHomeDesignFlow()) {
    return { translationKey: "homeDesignRoom", options: HOME_ROOM_OPTIONS }
  }
  return { translationKey: "mainGoal", options: MAIN_GOAL_OPTIONS }
}

export default function TryFirstSubPage() {
  const isFemale = getIsFemaleFromLocalStorage()
  const { translationKey, options } = getFlowConfig(isFemale)

  return <RadioCardListPage translationKey={translationKey} options={options} />
}
